import { Dependencies } from '../business-logic';
import { PASSENGER_NOTIFICATION_ASKED_ON_HOME_KEY } from '../hooks/useNotificationPermission';
import { useScheduleChangesStore } from '../hooks/useScheduleChangesStore';
import { localUserManager } from '../services/localUserManager';
import { personalDetailsManager } from '../services/personalDetailsManager';

export const wipeFEStorages = async (
	deps: Pick<Dependencies, 'db' | 'replications'>
) => {
	personalDetailsManager.clear();
	localUserManager.clear();

	// Clear home page notification flag so user gets asked again after next login
	localStorage.removeItem(PASSENGER_NOTIFICATION_ASKED_ON_HOME_KEY);
	useScheduleChangesStore.getState().reset();

	if (deps.replications) {
		const p = Object.values(deps.replications).map((replicationController) =>
			replicationController.stop()
		);

		await Promise.all(p);
	}

	await deps.db.remove();
};
